// components/Parrainage/ParrainageSection.jsx
import React, { useState } from "react";
import axios from "axios";
// import { toast } from "react-toastify";
import Button from "./../../../components/Button/Button";

export default function ParrainageSection() {
  const [showForm, setShowForm] = useState(true); // Formulaire visible par défaut
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    nom_parrain: "",
    prenom_parrain: "",
    club_parrain: "",
    email_parrain: "",
    telephone_parrain: "",
    club_parraine: "",
    nom_contact_parraine: "",
    prenom_contact_parraine: "",
    email_parraine: "",
    telephone_parraine: "",
  });

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    // Trim simple pour éviter les espaces parasites
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const resetForm = () => {
    setFormData({
      nom_parrain: "",
      prenom_parrain: "",
      club_parrain: "",
      email_parrain: "",
      telephone_parrain: "",
      club_parraine: "",
      nom_contact_parraine: "",
      prenom_contact_parraine: "",
      email_parraine: "",
      telephone_parraine: "",
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const res = await axios.post(
        "https://api.monappliclub.com/api/parrainage/addParrainage",
        formData
      );
      if (res.status === 200 || res.status === 201) {
        // toast.success("Parrainage envoyé avec succès !");
        resetForm();
        // On garde le formulaire ouvert pour proposer d’autres clubs
      } else {
        throw new Error("Réponse API inattendue");
      }
    } catch (error) {
      console.error("Erreur lors de l'envoi du parrainage :", error);
      // toast.error("Erreur lors de l'envoi du parrainage.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="mt-10">
      <div className="rounded-2xl overflow-hidden shadow ring-1 ring-slate-200/70 dark:ring-slate-700/70 bg-white/80 dark:bg-slate-900/60 backdrop-blur">
        {/* Bandeau dégradé d’accroche */}
        <div className="bg-gradient-to-r from-blue-500 via-violet-500 to-pink-500">
          <div className="px-5 py-8 sm:px-8 text-white">
            <h3 className="text-lg sm:text-xl font-semibold text-center">
              Parrainez une mairie et profitez d’avantages
            </h3>
            <div className="mt-3 text-sm/6 max-w-3xl mx-auto text-center space-y-1">
              <p>
                5% de réduction pour vous et la mairie parrainée.{" "}
                <span className="font-semibold">10%</span> si vous parrainez
                plusieurs mairies.
              </p>
              <p>
                Partagez l’application avec des mairies qui vous ressemblent et
                faites grandir la communauté.
              </p>
            </div>

            <div className="mt-5 flex flex-wrap items-center justify-center gap-2 text-[12px]">
              <span className="rounded-full bg-white/90 text-slate-900 px-3 py-1 font-semibold">
                Sans engagement
              </span>
              <span className="rounded-full bg-white/90 text-slate-900 px-3 py-1 font-semibold">
                Réponse sous 24h
              </span>
              <span className="rounded-full bg-white/90 text-slate-900 px-3 py-1 font-semibold">
                Avantages cumulables
              </span>
            </div>

            <div className="mt-5 text-center">
              <Button
                text={showForm ? "Masquer le formulaire" : "Parrainer un club"}
                onClick={() => setShowForm((v) => !v)}
                className="!bg-white !text-slate-900 hover:!bg-white/90 !rounded-xl !shadow-md"
              />
            </div>
          </div>
        </div>

        {/* Contenu */}
        <div className="px-5 pb-8 sm:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-5 gap-6 mt-6">
            {/* Colonne pitch + visuel */}
            <div className="order-2 lg:order-1 lg:col-span-2">
              <div className="rounded-xl border border-slate-200 dark:border-slate-800 bg-white/90 dark:bg-slate-900/40 p-5">
                <h4 className="text-base font-semibold text-slate-900 dark:text-slate-100">
                  Pourquoi parrainer ?
                </h4>
                <ul className="mt-2 space-y-2 text-sm text-slate-700 dark:text-slate-300">
                  <li>• Vous bénéficiez d’une remise immédiate.</li>
                  <li>
                    • La mairie parrainée démarre dans les meilleures conditions.
                  </li>
                  <li>• Vous contribuez à une communauté de mairies engagées.</li>
                </ul>

                <img
                  src="/img/parrainage_02.png"
                  alt="Parrainage"
                  className="mt-4 w-full rounded-lg object-cover ring-1 ring-slate-200 dark:ring-slate-800"
                />
              </div>
            </div>

            {/* Formulaire */}
            {showForm && (
              <div className="order-1 lg:order-2 lg:col-span-3">
                <form
                  onSubmit={handleSubmit}
                  className="rounded-xl border border-slate-200 dark:border-slate-800 bg-white/90 dark:bg-slate-900/40 p-5"
                >
                  <h4 className="text-base font-semibold text-slate-900 dark:text-slate-100 mb-3">
                    Proposer une mairie intéressée
                  </h4>

                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {/* Bloc Parrain */}
                    <div>
                      <p className="text-sm font-medium text-slate-800 dark:text-slate-100 mb-2">
                        Vos informations (parrain)
                      </p>
                      <input
                        name="club_parrain"
                        value={formData.club_parrain}
                        onChange={handleInputChange}
                        required
                        placeholder="Mairie parrain *"
                        className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 mb-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
                      />
                      <div className="grid grid-cols-2 gap-2">
                        <input
                          name="nom_parrain"
                          value={formData.nom_parrain}
                          onChange={handleInputChange}
                          required
                          placeholder="Nom *"
                          className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
                        />
                        <input
                          name="prenom_parrain"
                          value={formData.prenom_parrain}
                          onChange={handleInputChange}
                          required
                          placeholder="Prénom *"
                          className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
                        />
                      </div>
                      <input
                        name="email_parrain"
                        type="email"
                        value={formData.email_parrain}
                        onChange={handleInputChange}
                        required
                        placeholder="Email *"
                        className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 mt-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
                      />
                      <input
                        name="telephone_parrain"
                        type="tel"
                        inputMode="tel"
                        value={formData.telephone_parrain}
                        onChange={handleInputChange}
                        placeholder="Téléphone"
                        className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 mt-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
                      />
                    </div>

                    {/* Bloc Parrainé */}
                    <div>
                      <p className="text-sm font-medium text-slate-800 dark:text-slate-100 mb-2">
                        Mairie parrainée (contact)
                      </p>
                      <input
                        name="club_parraine"
                        value={formData.club_parraine}
                        onChange={handleInputChange}
                        required
                        placeholder="Mairie parrainée *"
                        className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 mb-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
                      />
                      <div className="grid grid-cols-2 gap-2">
                        <input
                          name="nom_contact_parraine"
                          value={formData.nom_contact_parraine}
                          onChange={handleInputChange}
                          placeholder="Nom du contact"
                          className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
                        />
                        <input
                          name="prenom_contact_parraine"
                          value={formData.prenom_contact_parraine}
                          onChange={handleInputChange}
                          placeholder="Prénom du contact"
                          className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
                        />
                      </div>
                      <input
                        name="email_parraine"
                        type="email"
                        value={formData.email_parraine}
                        onChange={handleInputChange}
                        placeholder="Email"
                        className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 mt-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
                      />
                      <input
                        name="telephone_parraine"
                        type="tel"
                        inputMode="tel"
                        value={formData.telephone_parraine}
                        onChange={handleInputChange}
                        placeholder="Téléphone"
                        className="w-full rounded-xl border border-slate-300 dark:border-slate-700 bg-white dark:bg-slate-900 text-slate-900 dark:text-slate-100 px-3 py-2 mt-2 focus:outline-none focus:ring-2 focus:ring-violet-400"
                      />
                    </div>
                  </div>

                  <p className="mt-3 text-xs text-slate-500 dark:text-slate-400">
                    Les champs marqués d’un * sont obligatoires. Nous ne
                    partagerons jamais vos informations à des tiers non
                    autorisés.
                  </p>

                  <div className="mt-4 flex justify-end gap-2">
                    <Button
                      text="Envoyer le parrainage"
                      type="submit"
                      className={`!rounded-xl ${
                        loading ? "opacity-60 pointer-events-none" : ""
                      }`}
                    />
                  </div>
                </form>
              </div>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
